/* Rippl home page: shared behaviour for every rhm- section (home study v133, approved).
   Source of truth: Claude OS/Rippl/dtc-online/homepage-redesign/theme-build/home/assets/rhm-home.js
   - (the custom cursor was dropped on 10 Oct 2026, Apple audit and Rule 57: the system pointer is back)
   - reveals: [data-rhm-reveal] gets .rhm-in when it comes on screen
   - section 3 (three ways), section 8 (sustainability), section 9 (Instagram)
   Loaded once per page by every section; each part is idempotent and re-runs on shopify:section:load. */
(function () {
  'use strict';
  var W = window, D = document;
  var reduce = W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var RHM = W.RHM = W.RHM || {};
  if (RHM.homeLoaded) { return; }
  RHM.homeLoaded = true;
  RHM.reduce = reduce;
  function all(sel, root) { return [].slice.call((root || D).querySelectorAll(sel)); }
  RHM.all = all;

  /* ---------- reveal ---------- */
  function reveal(root) {
    var els = all('[data-rhm-reveal]', root).filter(function (e) { return !e.__rv; });
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in W)) { els.forEach(function (e) { e.__rv = 1; e.classList.add('rhm-in'); }); return; }
    els.forEach(function (e) {
      e.__rv = 1;
      var t = parseFloat(e.getAttribute('data-rhm-reveal')) || 0.12;
      var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { e.classList.add('rhm-in'); io.disconnect(); } }); }, { threshold: t });
      io.observe(e);
    });
  }
  RHM.reveal = reveal;

  /* the custom cursor (dot and trailing ring) was dropped on 10 Oct 2026: Apple audit, Rule 57 */

  /* ---------- section 3: the panel edges follow the columns as they widen ---------- */
  function paths(sec) {
    if (sec.__rhm) return; sec.__rhm = 1;
    var grid = sec.querySelector('.rhm-pgrid'), pps = all('.rhm-pp', sec), v1 = sec.querySelector('.rhm-lv1'), v2 = sec.querySelector('.rhm-lv2');
    if (!grid || pps.length < 3) return;
    function wide() { return W.innerWidth >= 820; }
    function edges() { if (!wide()) return; var g = grid.getBoundingClientRect(); v1.style.left = (pps[1].getBoundingClientRect().left - g.left) + 'px'; v2.style.left = (pps[2].getBoundingClientRect().left - g.left) + 'px'; }
    function follow() { var t0 = performance.now(); (function f() { edges(); if (performance.now() - t0 < 1100) requestAnimationFrame(f); })(); }
    edges(); W.addEventListener('resize', edges);
    pps.forEach(function (p) { p.addEventListener('mouseenter', follow); p.addEventListener('mouseleave', follow); });
    function go() { sec.classList.add('rhm-in'); if (wide()) pps.forEach(function (p) { p.classList.add('rhm-in'); }); }
    if (reduce || !('IntersectionObserver' in W)) { go(); pps.forEach(function (p) { p.classList.add('rhm-in'); }); return; }
    /* the images start opening a little before the grid arrives, so nobody scrolls past an empty frame */
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) go(); }); }, { rootMargin: '0px 0px 22% 0px', threshold: 0 }).observe(grid);
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('rhm-in'); }); }, { rootMargin: '0px 0px 14% 0px', threshold: .04 });
    pps.forEach(function (p) { io.observe(p); });
  }

  /* ---------- section 8: the figures count up once; the visitor's own line ---------- */
  function sus(sec) {
    if (sec.__rhm) return; sec.__rhm = 1;
    var nums = all('[data-to]', sec), done = false;
    function fmt(v) { return Math.round(v).toLocaleString('en-AU'); }
    nums.forEach(function (el) { el.textContent = fmt(+el.dataset.to); });
    function run() {
      if (done) return; done = true; sec.classList.add('rhm-in'); if (reduce) return;
      nums.forEach(function (el, k) {
        var to = +el.dataset.to, t0 = 0, Dur = 1900, wait = 350 + k * 140; el.textContent = '0';
        setTimeout(function () { (function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / Dur), e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(to * e); if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(to); })(performance.now()); }, wait);
      });
    }
    var y = sec.querySelector('.rhm-susy');
    if (y) {
      var STEPS = (y.dataset.steps || '10,25,50,100,250,500,1000,2500').split(',').map(Number), per = +y.dataset.per || 7, si = Math.max(0, STEPS.indexOf(+y.dataset.start || 100));
      var cEl = y.querySelector('.rhm-susc'), nEl = y.querySelector('.rhm-susn'), bm = y.querySelector('.rhm-susm'), bp = y.querySelector('.rhm-susp'), shown = STEPS[si] * per * 12, raf = 0;
      var plan = function () {
        var c = STEPS[si], to = c * per * 12, from = shown, t0 = 0; cEl.textContent = fmt(c); bm.disabled = si === 0; bp.disabled = si === STEPS.length - 1; cancelAnimationFrame(raf);
        if (reduce) { shown = to; nEl.textContent = fmt(to); return; }
        raf = requestAnimationFrame(function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / 650), e = 1 - Math.pow(1 - p, 3); shown = from + (to - from) * e; nEl.textContent = fmt(shown); if (p < 1) raf = requestAnimationFrame(step); else shown = to; });
      };
      cEl.textContent = fmt(STEPS[si]); nEl.textContent = fmt(shown);
      bm.addEventListener('click', function () { if (si > 0) { si--; plan(); } });
      bp.addEventListener('click', function () { if (si < STEPS.length - 1) { si++; plan(); } });
    }
    if (reduce || !('IntersectionObserver' in W)) { run(); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) run(); }); }, { threshold: .28 }).observe(sec);
  }

  /* ---------- section 9: the hand opens with the scroll and leans towards the pointer ---------- */
  function soc(sec) {
    if (sec.__rhm) return; sec.__rhm = 1;
    var fan = sec.querySelector('.rhm-socf'), cap = sec.querySelector('.rhm-socn'); if (!fan || !cap) return;
    var sp = cap.querySelector('span'), home = sp.textContent, t = 0;
    function say(x) { if (sp.textContent === x) return; clearTimeout(t); cap.classList.add('rhm-sw'); t = setTimeout(function () { sp.textContent = x; cap.classList.remove('rhm-sw'); }, reduce ? 0 : 220); }
    fan.addEventListener('pointerover', function (e) { if (e.pointerType === 'touch') return; var c = e.target.closest && e.target.closest('.rhm-socc'); if (c) say(c.dataset.n); });
    fan.addEventListener('pointerleave', function () { say(home); fan.style.setProperty('--tilt', '0deg'); });
    fan.addEventListener('focusin', function (e) { var c = e.target.closest && e.target.closest('.rhm-socc'); if (c) say(c.dataset.n); });
    fan.addEventListener('focusout', function () { say(home); });
    if (reduce) { sec.classList.add('rhm-in'); return; }
    sec.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch') return; var r = sec.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5; fan.style.setProperty('--tilt', (x * 5).toFixed(2) + 'deg'); });
    var tick = 0;
    function prog() { tick = 0; var H = W.innerHeight, r = fan.getBoundingClientRect(), p = (H - r.top - H * .06) / (H * .62); p = Math.max(0, Math.min(1, p)); fan.style.setProperty('--p', (1 - Math.pow(1 - p, 3)).toFixed(4)); if (p > .02) sec.classList.add('rhm-in'); }
    fan.style.setProperty('--p', '0');
    W.addEventListener('scroll', function () { if (!tick) tick = requestAnimationFrame(prog); }, { passive: true });
    W.addEventListener('resize', prog); prog();
  }

  function boot() {
    reveal();
    all('.rhm-paths').forEach(paths);
    all('.rhm-sus').forEach(sus);
    all('.rhm-soc').forEach(soc);
  }
  RHM.bootHome = boot;
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', boot);
})();

/* Pre-publish sweep, 14 Oct 2026 (fix 8): the button family's press shows on pointer-down, so a finger sees it at once (Chrome holds
   :active back on touch while it decides whether the finger is scrolling). Registered once, however many sections load this file. */
(function () {
  if (window.__rhmDown) return; window.__rhmDown = true;
  var SEL = '.rhm-cta .rhm-pill,.rhm-hofb,.rhm-socb,.rhm-nshop,.rhm-frgo,.rhm-pv', cur = null;
  function off() { if (cur) { cur.classList.remove('rhm-down'); cur = null; } }
  document.addEventListener('pointerdown', function (e) { if (e.button > 0 || !e.target.closest) return; var t = e.target.closest(SEL); if (!t || t.disabled) return; off(); cur = t; t.classList.add('rhm-down'); }, { passive: true });
  ['pointerup', 'pointercancel', 'dragstart'].forEach(function (n) { document.addEventListener(n, off, { passive: true }); });
  document.addEventListener('pointerout', function (e) { if (cur && e.target === cur && !cur.contains(e.relatedTarget)) off(); }, { passive: true });
})();
